<section tuiContent>
	<p class="mb-4 color-tertiary">
		{{ 'select-organization.description' | transloco }}
	</p>

	<ctx-organization-selector
		[disabled]="busy()"
		(organizationSelected)="onOrganizationSelected($event)"
	/>
</section>
